<ppl-accordion [title]="'Application Summary'" [isOpen]="true"
    *authorize="[pageId, tabId, 'Summary', 'section']">
    <div class="tile-grid">

        @if (isDataLoaded) {
        @if(!isParticipantFlow) {

        @if (isPA && canViewW2) {
        <div class="tile">
            <p class="summary-heading">W2</p>
            <div class="button-container no-padding no-margin">
                <button class="download-welcome-letter btn btn-primary"
                    (click)="downloadW2()"
                    aria-label="Download your W2">View</button>
            </div>
        </div>
        }

        @for (association of associationMap; track $index) {
        <div class="tile">
            <p class="summary-heading">Welcome Letter
                ({{association.typeName}})</p>
            <div class="button-container no-padding no-margin">
                <button class="view-welcome-letter btn btn-info"
                    (click)="viewWelcomeLetter(association)"
                    aria-label="View your Welcome Letter">View</button>
                <button class="download-welcome-letter btn btn-primary"
                    (click)="handleDownload(association)"
                    aria-label="Download your Welcome Letter">Download</button>
            </div>
        </div>
        }
        }

        @for (appInfo of applicationInfoItems; track appInfo; let idx = $index )
        {
        <div class="tile">
            <p class="summary-heading">{{appInfo.summaryItemDisplayName}}</p>
            <p class="count">{{appInfo.summaryItemValue}}</p>
        </div>
        }

        @for (summaryItem of summaryItems; track summaryItem; let idx = $index )
        {
        <div class="tile">
            <p
                class="summary-heading">{{summaryItem.summaryItemDisplayName}}</p>
            <p class="count">{{summaryItem.summaryItemValue}}</p>
        </div>
        }

        @for (auth of authorizationItems; track auth; let idx = $index ) {
        <div class="tile">
            <p class="summary-heading">{{auth.summaryItemDisplayName}}</p>
            <p class="count">{{auth.summaryItemValue}}</p>
        </div>
        }

        @if (pendingTodoListCount || completedTodoListCount) {
        <div class="tile">
            <p class="summary-heading">To Do List</p>
            <div class="row text-center">
                <div class="col-6">
                    <p class="summary-subheading"><strong>Pending</strong></p>
                    <p class="count" aria-label="Pending count">
                        {{ pendingTodoListCount }}
                    </p>
                </div>
                <div class="col-6">
                    <p class="summary-subheading"><strong>Completed</strong></p>
                    <p class="count" aria-label="Completed count">
                        {{ completedTodoListCount }}
                    </p>
                </div>
            </div>
        </div>
        }

        @if (!isPA && isWeeklyUtilizationSummaryPresent) {
        <div class="tile wide-card">
            <p class="summary-heading">Current Pay Period Utilization</p>
            <div class="tile-container">
                <ng-container *ngIf="isSameMco; else showDifferentMcoTemplate">
                    <div *ngFor="let item of weeklyUtilizationData" class="mb-2"
                        [ngClass]="getUtilizationClass(item.utilizationPercent)">
                        {{item.mcoName}} - {{item.serviceDescription}} -
                        {{getCalculatedPtoHours(item.utilization)}}
                    </div>
                </ng-container>

                <ng-template #showDifferentMcoTemplate class="w-100">
                    <div class="mb-5 alert alert-warning">
                        You have conflicting Authorizations and therefore your
                        submission will be placed into PPL
                        review.
                    </div>
                </ng-template>
            </div>
        </div>
        }

        @if(canViewWorkHoursSummary && !readOnly) {
        <div class="tile">
            <p class="summary-heading">Monthly Hours Summary</p>
            <div class="button-container no-padding no-margin">
                <button class="download-welcome-letter btn btn-primary"
                    (click)="openPbiReportPopup()"
                    aria-label="Update now">Generate Summary</button>
            </div>
        </div>
        }

        @if (isProviderFlow && !readOnly && program?.program_code !== 'CASDP') {
        <ng-container *ngIf="!isHrStaff">
            <ppl-lead-detail-summary-training-tile
                [programCode]="program?.program_code ?? ''"
                [selectedProviderId]="selectedLead" />
        </ng-container>
        }
        }
    </div>
</ppl-accordion>

<div class="filter-panel">

    <ng-template #pdfDialog let-cancel="cancel">
        <div class *ngIf="pdfConfig && pdfFile">
            <ppl-editpdf (fieldsUpdated)="fieldsUpdated($event)"
                [readonly]="true" [pdfConfig]="pdfConfig"
                [signature] [pdfBlob]="pdfBlob" [pdfFile]="pdfFile"
                [signatureId]
                [isParticipantFlow]="isParticipantFlow"
                [selectedParticipantId]="selectedLead"
                [isSelf]="true"></ppl-editpdf>
        </div>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #pbiReportDialog let-cancel="cancel">
        <div>
            <ppl-dropdown-select
                id="selectedAttribute"
                placeholder="Select Lookup Period"
                [options]="pbiDropdownOptions"
                [optionLabel]="'attribute_text'"
                [optionValue]="'value'"
                optionDisabled="disabled"
                required="true"
                aria-required="true"
                arialabel="Select Lookup"
                [attr.aria-label]="'Select Lookup'"
                (selectionChange)="selectedPbiMonths = $event"
                style="width: 100%; margin-bottom: 16px">
            </ppl-dropdown-select>
        </div>
    </ng-template>
</div>